const legal_notice =
  "<h1>Impressum</h1>\n" +
  "<p></p>" +
  "              <h2>Angaben gem&auml;&szlig; &sect; 5 TMG</h2>\n" +
  "              <p>\n" +
  "                Caspari, Schmidt-Mosig und Wendt - vetvise GbR<br />\n" +
  "                Sandbergstr. 95<br />\n" +
  "                26180 Rastede\n" +
  "              </p>\n" +
  "\n" +
  "              <h2>Kontakt</h2>\n" +
  "              <p>\n" +
  "                Telefon: +49 176 5762 1254<br />\n" +
  "                E-Mail: info@vetvise.com\n" +
  "              </p>\n" +
  "\n" +
  "              <h2>Streitschlichtung</h2>\n" +
  "              <p>\n" +
  "                Die Europ&auml;ische Kommission stellt eine Plattform zur\n" +
  "                Online-Streitbeilegung (OS) bereit:\n" +
  "                <a\n" +
  '                  class="source"\n' +
  '                  href="https://ec.europa.eu/consumers/odr"\n' +
  '                  target="_blank"\n' +
  '                  rel="noopener"\n' +
  "                  >https://ec.europa.eu/consumers/odr</a\n" +
  "                >.<br />\n" +
  "                Unsere E-Mail-Adresse finden Sie oben im Impressum.\n" +
  "              </p>\n" +
  "\n" +
  "              <p>\n" +
  "                Wir sind nicht bereit oder verpflichtet, an\n" +
  "                Streitbeilegungsverfahren vor einer\n" +
  "                Verbraucherschlichtungsstelle teilzunehmen.\n" +
  "              </p>\n" +
  "\n" +
  "              <h3>Haftung f&uuml;r Inhalte</h3>\n" +
  "              <p>\n" +
  "                Als Diensteanbieter sind wir gem&auml;&szlig; &sect; 7 Abs.1 TMG\n" +
  "                f&uuml;r eigene Inhalte auf diesen Seiten nach den allgemeinen\n" +
  "                Gesetzen verantwortlich. Nach &sect;&sect; 8 bis 10 TMG sind wir\n" +
  "                als Diensteanbieter jedoch nicht verpflichtet, &uuml;bermittelte\n" +
  "                oder gespeicherte fremde Informationen zu &uuml;berwachen oder\n" +
  "                nach Umst&auml;nden zu forschen, die auf eine rechtswidrige\n" +
  "                T&auml;tigkeit hinweisen.\n" +
  "              </p>\n" +
  "              <p>\n" +
  "                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von\n" +
  "                Informationen nach den allgemeinen Gesetzen bleiben hiervon\n" +
  "                unber&uuml;hrt. Eine diesbez&uuml;gliche Haftung ist jedoch erst\n" +
  "                ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung\n" +
  "                m&ouml;glich. Bei Bekanntwerden von entsprechenden\n" +
  "                Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.\n" +
  "              </p>\n" +
  "              <h3>Haftung f&uuml;r Links</h3>\n" +
  "              <p>\n" +
  "                Unser Angebot enth&auml;lt Links zu externen Websites Dritter,\n" +
  "                auf deren Inhalte wir keinen Einfluss haben. Deshalb k&ouml;nnen\n" +
  "                wir f&uuml;r diese fremden Inhalte auch keine Gew&auml;hr\n" +
  "                &uuml;bernehmen. F&uuml;r die Inhalte der verlinkten Seiten ist\n" +
  "                stets der jeweilige Anbieter oder Betreiber der Seiten\n" +
  "                verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der\n" +
  "                Verlinkung auf m&ouml;gliche Rechtsverst&ouml;&szlig;e\n" +
  "                &uuml;berpr&uuml;ft. Rechtswidrige Inhalte waren zum Zeitpunkt\n" +
  "                der Verlinkung nicht erkennbar.\n" +
  "              </p>\n" +
  "              <p>\n" +
  "                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist\n" +
  "                jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht\n" +
  "                zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir\n" +
  "                derartige Links umgehend entfernen.\n" +
  "              </p>\n" +
  "              <h3>Urheberrecht</h3>\n" +
  "              <p>\n" +
  "                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf\n" +
  "                diesen Seiten unterliegen dem deutschen Urheberrecht. Die\n" +
  "                Vervielf&auml;ltigung, Bearbeitung, Verbreitung und jede Art der\n" +
  "                Verwertung au&szlig;erhalb der Grenzen des Urheberrechtes\n" +
  "                bed&uuml;rfen der schriftlichen Zustimmung des jeweiligen Autors\n" +
  "                bzw. Erstellers. Downloads und Kopien dieser Seite sind nur\n" +
  "                f&uuml;r den privaten, nicht kommerziellen Gebrauch gestattet.\n" +
  "              </p>\n" +
  "              <p>\n" +
  "                Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt\n" +
  "                wurden, werden die Urheberrechte Dritter beachtet. Insbesondere\n" +
  "                werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie\n" +
  "                trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,\n" +
  "                bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden\n" +
  "                von Rechtsverletzungen werden wir derartige Inhalte umgehend\n" +
  "                entfernen.\n" +
  "              </p>\n" +
  "\n" +
  "              <p>\n" +
  "                Quelle:\n" +
  '                <a class="source" href="https://www.e-recht24.de">eRecht24</a>\n' +
  "              </p>";
export default legal_notice;
